import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M5 7c0-.552.392-1 .875-1h12.25c.483 0 .875.448.875 1s-.392 1-.875 1H5.875C5.392 8 5 7.552 5 7M5 12c0-.552.392-1 .875-1h12.25c.483 0 .875.448.875 1s-.392 1-.875 1H5.875C5.392 13 5 12.552 5 12M5 17c0-.552.392-1 .875-1h12.25c.483 0 .875.448.875 1s-.392 1-.875 1H5.875C5.392 18 5 17.552 5 17",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-menu"}) } }